import styled, { css } from 'styled-components'
import ReactSelect from 'react-select'
import Highlighter from 'react-highlight-words'

interface SelectProps {
  hasError?: boolean
}

const customSharedSelectStyles = css`
  .reactSelect {

    &__menu-list {
      max-height: 175px;
    }

    &__input {
      opacity: 1 !important;
      flex: 11;
    }

    &__input-container {
      display: flex !important;

      &::after {
        flex: 1;
      }
    }

    &__control {
      height: 48px;
      border-radius: 5px;
      padding-left: 10px;
      cursor: pointer;

      &:hover {
        border-color: #c3c3c3;
      }

      &--is-focused, &--menu-is-open {
        border-color: #c3c3c3;
        box-shadow: none;
      }
    }

    &__placeholder {
      color: #c1c1c1;
    }

    &__indicator-separator {
      display: none;
    }

    &__clear-indicator > svg:hover {
      filter: brightness(1.1);
    }

    &__menu {
      margin-top: 0;
      margin-bottom: 0;
    }

    &__option {
      cursor: pointer;
      height: 48px;
      display: flex;
      align-items: center;
      white-space: pre-wrap;

      &:hover {
        color: #1f35b5;
        background-color: #e8eaf8;
      }

      &--is-focused {
        color: #4b4b4b;
        background-color: transparent;
      }

      &--is-selected {
        color: #1f35b5;
        background-color: initial;
      }
    }
  }
`

export const Wrapper = styled.div`
  position: relative;
`

export const Select = styled(ReactSelect)<SelectProps>`
  ${customSharedSelectStyles}

  .reactSelect__control {
    border-color: ${(props) => props.hasError ? '#FF4949' : ''};

    &:hover {
      border-color: ${(props) => props.hasError ? '#FF4949' : ''};
    }
  }
`

export const CustomClearIndicator = styled.div`
  display: flex;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  
  &:hover {
    filter: brightness(1.1);
  }
`

export const CustomHighlighter = styled(Highlighter).attrs(() => ({
  highlightStyle: { backgroundColor: '#FFFEB5' }
}))``